// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable-next-line selector-max-specificity -- hiding native calendar icon */
.DateInput-module__HideNativeCalendarIcon__KTiKo::-webkit-calendar-picker-indicator {
    display: none;
}
/* stylelint-disable-next-line selector-max-specificity -- Safari has an additional element inside the input which contains the editable values for year/month/day  */
.DateInput-module__AdjustInputSizeForSafari__Q4dWg::-webkit-datetime-edit {
    display: block;
    height: var(--ds-l);
    padding: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"HideNativeCalendarIcon": `DateInput-module__HideNativeCalendarIcon__KTiKo`,
	"AdjustInputSizeForSafari": `DateInput-module__AdjustInputSizeForSafari__Q4dWg`
};
export default ___CSS_LOADER_EXPORT___;
